import { ProductAPI } from "@/api";
import type { TInspectionListData } from "@/types/used-product.type.ts";

export default function loadHealthInspectionData(): Promise<TInspectionListData> {
  return ProductAPI.getInspectionList();
}
